import { render, staticRenderFns } from "./livestockSummaryYoungBull.vue?vue&type=template&id=72286df1&scoped=true&"
import script from "./livestockSummaryYoungBull.vue?vue&type=script&lang=js&"
export * from "./livestockSummaryYoungBull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72286df1",
  null
  
)

export default component.exports